export function reverseString(value: string, separator: string) {
  return value.split(separator).reverse().join(separator);
}
